<script>
export default {
    name: "ReverseProcessForm",

    data() {

        return {
            comment: ``,
        };
    },

    props: {

        drug: Object,
        patient: Object,
        showModal: Boolean,
    },

    computed: {

        reverseProcessedDrugs() {

            return {
                patientID: this.patient.patienT_ID,
                patientName: this.patient.names,
                visitNo: this.patient.visitNo,
                userName: this.$root.username,
                code: this.drug.patientPrescriptionId,
                comment: this.comment,
            };
        },
    },

    methods: {

        saveData() {
            this.$root.loading = true;
            this.$http.post(`Pharmacy/ReverseProcessedDrugs`, this.reverseProcessedDrugs).then(response => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: response.data, });
            }).catch(() => {  this.$root.loading = false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-11/12 md:w-1/2">
          <template v-slot:title>
            <h5 class="text-base font-medium">Reverse Processed Drug</h5>
          </template>
          <template v-slot:modal-body>
            <div class="flex flex-wrap -m-3">
                <div class="w-full p-tiny flex md:flex-row sm:flex-col bg-gray-300 text-sm">
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-blue-800">{{ drug.service }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-blue-800">Dosage: {{ drug.dosage }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-blue-800">Ordered: {{ drug.dosage }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-blue-800">Remaining: {{ drug.remainingDOsage }}</h5>
                    </div>
                </div>
                <div class="w-full p-tiny">
                    <label for="grid-comment-reverse-processed" class="label-control">Comment:</label>
                    <textarea v-model.trim="comment" id="grid-comment-reverse-processed" rows="4" class="input-control input-sm text-xs"></textarea>
                </div>
            </div>
          </template>
          <template v-slot:modal-footer>
            <button class="btn-danger btn-sm text-xs rounded mr-6" @click="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Cancel</button>
            <button class="btn-primary btn-sm text-xs rounded" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
          </template>
    </tail-modal>
</template>